import { fetcher } from '@utils/fetcher';
import {
  PlatformUserAddress,
  PlatformUserAddressDto,
} from '@interfaces/platformUserAddress/platformUserAddress';
import { CepResponse } from '@interfaces/platformUserAddress/cepResponse';

const API_URL = '/api/platformUserAddress';

export const findPlatformUserAddress = async (): Promise<PlatformUserAddress> =>
  fetcher(`${API_URL}/findOne`, { method: 'GET' });

export const upsertPlatformUserAddress = async (dto: PlatformUserAddressDto) =>
  fetcher(`${API_URL}/upsert`, {
    method: 'PUT',
    body: dto,
  });

export const getAddressByCep = async (cep: string): Promise<CepResponse> =>
  fetcher(`${API_URL}/cep/${cep}`, { method: 'GET' });
